import React from 'react';
import { connect } from 'react-redux';
import { default as __ } from '../../utils';

import { gameSelector } from '../../reducers/selectors';

import Sidebar from '../../components/ui/sidebar';
import Onboarding from './onboarding';
import ActionBar from './action-bar';
import FooterBar from './footer-bar';
import Stats from './stats';

let MIN_GAMES = 3;

const ConnectedDash = props => {
  const {
    left,
    minutes,
    rivals,
    streakWins,
    teammate,
    universe,
    victories,
    victoriesLeft,
  } = props.datum;

  if (universe < MIN_GAMES) {
    return (
      <>
        <Sidebar>
          <ActionBar />
        </Sidebar>
        <Onboarding left={MIN_GAMES - universe} />
      </>
    );
  } else {
    return (
      <>
        <Sidebar>
          <ActionBar />
        </Sidebar>

        <main className="owl-xl">
          <Stats.Results universe={universe} victories={victories} />
          <Stats.Positions
            universe={universe}
            victories={victories}
            victoriesLeft={victoriesLeft}
            left={left}
          />

          <Stats.Teammates universe={universe} teammate={teammate} />

          {universe >= 3 && (
            <Stats.Rivals universe={universe} rivals={rivals} />
          )}

          <Stats.PlayTime minutes={minutes} />
          {universe >= 5 && (
            <Stats.Advice
              universe={universe}
              rivals={rivals}
              streakVictories={streakWins}
            />
          )}
        </main>

        <FooterBar />
      </>
    );
  }
};

const select = state => {
  const datum = gameSelector(state);
  return { datum };
};

const Dash = connect(select, null)(ConnectedDash);

export default Dash;
